import React from "react";
import { Card, CardContent, Typography, CardMedia } from "@mui/material";

import { format, differenceInYears } from "date-fns";
import { getChildImageUrl } from "../imageUtils";

const ChildCard: React.FC<any> = ({ child }) => {
  return (
    <Card variant="outlined">
      <CardMedia
        component="img"
        sx={{
          objectFit: "contain",
          width: "100%",
          height: "auto",
        }}
        image={getChildImageUrl(child.photoId, 'w500')} title={child.registration.childFirstName} />
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Child Information
        </Typography>
        <Typography variant="h5" component="div">
          {child.registration.childFirstName} {child.registration.childMiddleName} {child.registration.childLastName} ({child.registration.childSex})
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          Age: {differenceInYears(new Date(), new Date(child.registration.childDateOfBirth))} ({format(new Date(child.registration.childDateOfBirth), "yyyy-MMM-dd")})
        </Typography>
        <Typography variant="body2">Food Preference: {child.registration.childFoodPref}</Typography>
        <Typography variant="body2">Allergens: {child.registration.childAllergens}</Typography>
        <Typography variant="body2">Health conditions: {child.registration.childHealth}</Typography>
        <Typography variant="body2">Other needs: {child.registration.childOtherDetails}</Typography>
      </CardContent>
    </Card>
  );
};

export default ChildCard;
